<template>
    <div>
        <b-container fluid>
            <h3 class="mt-3 mb-3">Client</h3>

            <Pagination
                :totalRows="total_rows"
                :perPage="rows_per_page"
                :onPageChange="onPageChange"
                :pagingLimit="paging_limit"
                :currentPage="currentPage"
                :onPerPageChange="onPerPageChange"
            />

            <b-table
                responsive
                small
                outlined
                striped
                hover
                sticky-header="500px"
                :items="items"
                :fields="fields"
            >
                <template v-slot:cell(fulfil_weight_optional)="data">
                    <b-form-checkbox
                        switch
                        :checked="data.item.fulfil_weight_optional == 1"
                        :disabled="!canEdit"
                        @change="onToggle(data.item, 'fulfil_weight_optional', $event)"
                    />
                </template>

                <template v-slot:cell(enable_cross_platform_transfer)="data">
                    <b-form-checkbox
                        switch
                        :checked="data.item.enable_cross_platform_transfer == 1"
                        :disabled="!canEdit"
                        @change="onToggle(data.item, 'enable_cross_platform_transfer', $event)"
                    />
                </template>
            </b-table>

            <Pagination
                :totalRows="total_rows"
                :perPage="rows_per_page"
                :onPageChange="onPageChange"
                :pagingLimit="paging_limit"
                :currentPage="currentPage"
                :onPerPageChange="onPerPageChange"
            />
        </b-container>
    </div>
</template>

<script>
import moment from "moment";
import Pagination from "./common/Pagination";
import global_function from "../mixins/global_function";

const fields = [
    {
        key: "client_name",
        label: "Client Name"
    },
    {
        key: "full_name",
        label: "Full Name"
    },
    {
        key: "fulfil_weight_optional",
        label: "Fulfil Weight Optional"
    },
    {
        key: "enable_cross_platform_transfer",
        label: "Cross-Platform Transfer"
    }
];

export default {
    name: "CmsClient",
    mixins: [global_function],
    inject: [
        "API_HOST",
        "TABLE_LIMIT",
        "PAGING_LIMIT",
        "DEFAULT_ROWS_PER_PAGE"
    ],
    components: {
        Pagination
    },
    data() {
        return {
            loader: false,
            items: [],
            fields: fields,
            currentPage: 1,
            total_rows: 0,
            rows_per_page: this.DEFAULT_ROWS_PER_PAGE,
            paging_limit: this.PAGING_LIMIT,
            search_criteria: {}
        };
    },
    async created() {
        if (!this.checkPermission(
            this.$store.state.user_obj,
            'Account',
            'Client',
            'View',
            true
        )) {
            this.$router.replace('/');
            return;
        }

        await this.getClientProfile();
        this.initialized = true;
    },
    mounted() {
        if (!this.checkPermission(
            this.$store.state.user_obj,
            'Account',
            'Client',
            'View',
            true
        )) {
            return;
        }

        this.loader = this.$loading.show({
            isFullPage: true,
            canCancel: false
        });
    },
    computed: {
        canEdit: function() {
            return this.checkPermission(
                this.$store.state.user_obj,
                'Account',
                'Client',
                'Edit',
                true
            );
        },
        table_offset: function() {
            return (this.currentPage - 1) * this.rows_per_page;
        }
    },
    methods: {
        async getClientProfile() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "cms_client_profile_get.php",
                data: {
                    offset: this.table_offset,
                    limit: this.rows_per_page,
                    search_criteria: this.search_criteria,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });
            this.items = response.data.clients;
            this.total_rows = parseInt(response.data.total_rows);
            this.loader.hide();
        },

        onSearch() {
          for (const key in this.search_criteria) {
            if (typeof this.search_criteria[key] === "string") {
              this.search_criteria[key] = this.search_criteria[key].trim();
            }
          }
            this.getClientProfile();
        },

        onPageChange(page_to_change) {
            this.currentPage = page_to_change;
            this.getClientProfile();
        },

        onPerPageChange(_perPage) {
            this.currentPage = 1;
            this.rows_per_page = _perPage;
            this.getClientProfile();
        },

        async onToggle(item, field, value) {
            const previous = item[field];
            this.$set(item, field, value ? 1 : 0);
            try {
                let response = await this.$http({
                    method: "POST",
                    baseURL: `${this.API_HOST}`,
                    url: "cms_client_profile_toggle.php",
                    data: {
                        client_profile_id: item.id,
                        field: field,
                        enabled: value,
                        user_id: this.$store.state.user_obj.user_id
                    }
                });
                if (response.data.status !== "success") {
                    throw new Error(response.data.message);
                }
            } catch (e) {
                this.$set(item, field, previous);
                alert("Failed to update client");
            }
        }
    }
};
</script>

<style>
th,
td {
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/CmsClient.vue